/**
 * Canonical greeting template placeholder names (`{{NAME}}` tokens).
 * Mirrors `PlaceholderNames` in the API — keep both lists in sync; drift is
 * guarded by `PlaceholderNamesDriftTests` on the backend and frontend tests.
 */
export const GreetingTemplatePlaceholder = {
  RECIPIENT_NAME: 'RECIPIENT_NAME',
  RECIPIENT_FIRST_NAME: 'RECIPIENT_FIRST_NAME',
  SENDER_NAME: 'SENDER_NAME',
} as const;

/**
 * All supported placeholder name strings, for iteration and guards.
 */
export const ALL_GREETING_TEMPLATE_PLACEHOLDER_NAMES: readonly string[] = [
  GreetingTemplatePlaceholder.RECIPIENT_NAME,
  GreetingTemplatePlaceholder.RECIPIENT_FIRST_NAME,
  GreetingTemplatePlaceholder.SENDER_NAME,
];
